import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from 'react-alert';
import { UserContext } from "../../../UserContext";
import { DateTime } from 'luxon';


import ClockIcon from "../../../../../../assets/images/user_app/mission_card/clock_icon.svg"
import { ScheduledEventTiming } from "../mission_components/mission_contents/MissionScheduled";
import Button from "../common_components/Button";
import TextButton from "../common_components/TextButton";

function InterviewCard({ interview, timeZone }) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { user, setUser, refreshUser } = useContext(UserContext);

    const [joinEnabled, setJoinEnabled] = useState(false);

    const isMobile = window.innerWidth <= 840;
    const buttonSize = isMobile ? "small" : "medium";

    function joinMeeting() {
        window.open(interview.meeting_link, "_blank");
    }

    function editMeeting() {
        navigate(`/missions/${interview.mission_id}`);
    }

    // Check if the scheduled event is within 10 minutes of the start time.
    function isScheduledEventWithin10Min(startTime, endTime, timeZone) {
        const now = DateTime.now().setZone(timeZone);
        const start = DateTime.fromISO(startTime, { zone: timeZone });
        const end = DateTime.fromISO(endTime, { zone: timeZone });

        return now >= start.minus({ minutes: 10 }) && now <= end;
    }

    // Check if the scheduled event is within 10 minutes of the start time.
    useEffect(() => {
        const interval = setInterval(() => {
            const isNowWithin10Min = isScheduledEventWithin10Min(interview.start_time, interview.end_time, timeZone);

            setJoinEnabled(isNowWithin10Min);
        }, 30000); // every 30 seconds

        return () => clearInterval(interval); // cleanup on unmount
    }, [interview, timeZone]);

    return (
        <div className="interview-card">
            <div className="interview-card-content-container">
                <div className="interview-card-content-except-type-container">
                    <div className="interview-card-title-and-description-container">
                        <ScheduledEventTiming scheduledEvent={interview} timeZone={timeZone} formatType="interview" />
                        <div className="interview-card-description body-large">
                            Interview for {interview.mission_name}
                        </div>
                    </div>
                    <div className="interview-card-reward-container">
                        <h2 className="interview-card-reward-amount">
                            {interview.reward}
                        </h2>
                        <div className="interview-card-reward-description body-small">
                            Reward
                        </div>
                    </div>
                </div>
                <div className="interview-card-type-container">
                    <img src={ClockIcon} alt="Clock Icon" className="interview-card-clock-icon" />
                    <div className="interview-card-type-description body-small">
                        {interview.format}
                    </div>
                </div>
            </div>
            <div className="interview-card-horizontal-divider" />
            <div className="interview-card-action-container">
                <div className="interview-card-scheduled-badge-and-note-container">
                    <div className="interview-card-scheduled-badge">
                        Scheduled
                    </div>
                    <div className="interview-card-scheduled-note body-tiny">
                        You've been emailed a calendar invite.
                    </div>
                </div>
                <div className="interview-card-action-buttons-container">
                    <Button color="primary" size={buttonSize} type="button" disabled={!joinEnabled} onClick={() => joinMeeting()} >Join Meeting</Button>
                    <Button color="gray" size={buttonSize} type="button" onClick={() => editMeeting()} >Change</Button>
                </div>
            </div>
        </div>
    );

}

export default InterviewCard;